import { DefaultTheme } from 'styled-components';

export const defaultTheme: DefaultTheme = {
  font: {
    family: '"Source Sans Pro", sans-serif',
    size: '14px',
  },
  colors: {
    bg: '#e5e5e5',
    text: '#4f4e4e',
    primary: '#6400AA',
    secondary: '#a3a3a3',
    light: '#f5f5f5',
    success: '#1ad743',
    danger: '#d87675',
    white: '#ffffff',
    black: '#121F3E',
    getStartedBtn: '#6400AA',
    customerChat: '#6400AA',
    headerBg: 'glass',
  },
  border: {
    radius: '6px',
  },
};
